module.exports = __webpack_public_path__ + "static/media/horma-estrecha.81605897.png";